<template>
    <div>
        <div class="inner">
            <el-row class="onlyMobile">
                <el-col>
                    <h3>Changelog</h3>
                </el-col>
            </el-row>
            <div class="changelog" v-loading="loading">
                <markdown-html v-if="!loading" />
            </div>
        </div>
    </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import { apiClass } from '../../../classes/api.class'
import { htmlClass } from '../../../classes/html.class'
import MarkdownHtml from '../../../components/Sdk/MarkdownHtml'
import { ROUTING } from '../../../const/routing.const'
import { ToolsClass } from '../../../classes/tools.class'

export default {
  name: 'AutopaySdkChangelogAndroidView',
  components: {
    MarkdownHtml
  },
  props: {
    selectedDevice: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: true
  }),
  methods: {
    ...mapMutations([
      'setSdkCurrentDevice'
    ]),
    getHtmlFile (device) {
      this.loading = true
      device = device || this.selectedDevice
      if (!this.lang || !this.version) {
        setTimeout(() => {
          this.getHtmlFile()
        }, 100)
        return
      }
      apiClass.getSdkFile(this.version, 'changelog-', device, this.lang, '.html')
        .then(
          response => {
            try {
              htmlClass.prepareHtml(response)
              setTimeout(() => {
                if (window.location.hash && window.location.hash.length > 1) {
                  const searchedHeading = document.querySelector(window.location.hash)
                  if (searchedHeading) {
                    ToolsClass.moveToElement(searchedHeading)
                  } else {
                    window.location.hash = ''
                  }
                }
              })
            } catch (err) {
              console.error(err)
            }
          },
          error => {
            console.error(error)
          })
        .finally(() => {
          this.loading = false
        })
    }
  },
  computed: {
    ...mapState({
      lang: state => state.sdk.lang,
      version: state => state.sdk.version,
      device: state => state.sdk.device
    })
  },
  watch: {
    device: function (value) {
      if (value !== this.selectedDevice) {
        this.$router.push(ROUTING.autopaySdk.changelog[value])
        this.getHtmlFile(value)
      }
    },
    lang: function (newValue, oldValue) {
      if (oldValue) {
        this.getHtmlFile()
      }
    },
    version: function (newValue, oldValue) {
      if (oldValue) {
        this.getHtmlFile()
      }
    }
  },
  created () {
    this.setSdkCurrentDevice(this.selectedDevice)
    this.getHtmlFile()
  }
}
</script>
<style src="../../../assets/scss/FilesDevice.scss" lang="scss"></style>
